import React, { useState, useEffect } from "react";
import Shell from "components/Shell";
import { getAll, getActiveCampaigns } from "api";
import { CAMPAIGN_NAMES, HEADERS } from "config";
import { getExcludedCategories } from "helpers";

const props = {
  adFormatName: CAMPAIGN_NAMES.SWIPEUP,
  tableHeaders: HEADERS.SWIPEUP,
  defaultValues: {
    campaignData: {
      type: "crea",
      creaCta: "Voir plus",
    },
  },
};

export default () => {
  const [data, setData] = useState([]);
  const [otherCampaignsData, setOtherCampaignsData] = useState([]);

  const refresh = () => {
    getAll(CAMPAIGN_NAMES.SWIPEUP.short)
      .then((data) => setData(data?.ads ?? []))
      .catch(console.log);

    Promise.all([
      getActiveCampaigns(CAMPAIGN_NAMES.NOTIFAD.short).catch(() => ({
        ads: [],
      })),
      getActiveCampaigns(CAMPAIGN_NAMES.SLIDE.short).catch(() => ({
        ads: [],
      })),
    ])
      .then(([notifAdRes, slideRes]) => {
        const combinedActive = [
          ...(notifAdRes?.ads ?? []),
          ...(slideRes?.ads ?? []),
        ];
        setOtherCampaignsData(combinedActive);
      })
      .catch(console.log);
  };

  useEffect(() => {
    refresh();
  }, []);

  // Extract category values to exclude from the campaign prop
  const excludedCategoryValues = getExcludedCategories(otherCampaignsData);

  return (
    <Shell
      {...props}
      campaignsData={data}
      refresh={refresh}
      excludedCategoryValues={excludedCategoryValues}
    />
  );
};
